
import React from 'react';
import { Header } from '../../components/feature/Header';
import { PortalHeroSection } from './components/HeroSection';
import { MarqueeBar } from './components/MarqueeBar';

import { AboutDTCP } from './components/AboutDTCP';
import { DepartmentSection } from './components/DepartmentSection';
import { KeyServicesSection } from './components/KeyServicesSection';
import { ModulesSection } from '../../components/feature/ModulesSection';


import { CitizenServicesSection } from './components/CitizenServicesSection';

import { AnnouncementSection } from './components/AnnouncementSection';
import { GallerySection } from './components/GallerySection';
import { PortalFooter } from './components/PortalFooter';
import { UdaLanding } from './components/UdaLanding';
import { PortalProvider, usePortal } from './PortalContext';
import { getUdaThemeById, accentVars } from './udaThemes';

const HomeContent: React.FC = () => {
  const { siteId, resetToDefault, authResolved } = usePortal();
  const isDTCP = siteId === 9;
  // A logged-in UDA user keeps the standard DTCP-style home (rotating hero carousel
  // scoped to their site); the themed UdaLanding is only for map/subdomain browsing.
  const udaTheme = (isDTCP || authResolved) ? null : getUdaThemeById(siteId);

  // On a UDA page, set the accent vars here (the root) so both the Header and
  // the UdaLanding sections below inherit this UDA's colour. DTCP / default
  // pages leave them unset → the :root orange defaults apply.
  const rootStyle = udaTheme ? (accentVars(udaTheme.accent) as React.CSSProperties) : undefined;

  return (
    <div className="min-h-screen bg-white dark:bg-[#0f1117]" style={rootStyle}>
      <Header />
      {/* Target for the header's "Skip to main content" link */}
      <main id="main-content">
        {udaTheme ? (
          /* Dedicated, per-UDA themed landing */
          <UdaLanding theme={udaTheme} onBackToDtcp={resetToDefault} />
        ) : (
          /* Default DTCP home */
          <>
            <PortalHeroSection />
            <MarqueeBar />
            <AboutDTCP />
            <DepartmentSection />
            <KeyServicesSection />
            <ModulesSection />
            <CitizenServicesSection />
            <AnnouncementSection />
            <GallerySection />
          </>
        )}
      </main>
      <PortalFooter />
    </div>
  );
};

export const HomePage: React.FC = () => {
  return (
    <PortalProvider>
      <HomeContent />
    </PortalProvider>
  );
};
